import { FileText, Clock } from 'lucide-react';
import { Sidebar } from '@/components/Sidebar';
import { MobileBottomNav } from '@/components/MobileBottomNav';
import Spinner from '@/components/Spinner';

export function LoadingState() {
  return (
    <div className="main-layout">
      <Sidebar />
      <main className="main-content dot-grid mobile-layout-offset">
        <div className="page-container flex items-center justify-center py-20">
          <Spinner label="Loading audit trail" />
        </div>
      </main>
      <MobileBottomNav />
    </div>
  );
}

export function NoTrustState() {
  return (
    <div className="main-layout">
      <Sidebar />
      <main className="main-content dot-grid mobile-layout-offset">
        <div className="page-container">
          <div className="card-trust corner-mark p-12 flex flex-col items-center justify-center">
            <FileText className="w-12 h-12 text-muted-foreground/60 mb-3" />
            <h2 className="text-xl font-semibold text-navy mb-1">Select a trust</h2>
            <p className="text-sm text-muted-foreground">
              Choose a trust to view the audit trail.
            </p>
          </div>
        </div>
      </main>
      <MobileBottomNav />
    </div>
  );
}

export function EmptyState() {
  return (
    <div className="card-trust corner-mark text-center py-12">
      <Clock className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
      <h3 className="font-serif text-lg text-navy mb-2">No Audit Events</h3>
      <p className="text-sm text-muted-foreground">
        Actions taken on this trust will appear here as a permanent record.
      </p>
    </div>
  );
}